import {
  ActionIcon,
  Group,
  MultiSelect,
  MultiSelectProps,
  Select,
  SelectProps,
  Tooltip,
} from '@mantine/core';
import { IconRefresh } from '@tabler/icons-react';

import { useGetManyMedicalSpecialitiesQuery } from '@api/medicalSpecialities.api';

type MedicalSpecialitySelectorProps =
  | (Omit<
      SelectProps,
      'data' | 'searchable' | 'nothingFoundMessage' | 'placeholder'
    > & {
      multiple?: false;
    })
  | (Omit<
      MultiSelectProps,
      'data' | 'searchable' | 'nothingFoundMessage' | 'placeholder'
    > & {
      multiple: true;
    });

export default function MedicalSpecialitySelector(
  props: MedicalSpecialitySelectorProps,
) {
  // ==========================================================================
  // Api
  // ==========================================================================
  const {
    data = [],
    isLoading,
    refetch,
  } = useGetManyMedicalSpecialitiesQuery({
    sortBy: 'name',
    sortOrder: 'asc',
  });

  // ==========================================================================
  // Render
  // ==========================================================================
  return props.multiple ? (
    <MultiSelect
      {...props}
      label={
        <Group
          display="inline-flex"
          w="max-content"
          gap="0.2rem"
          align="center"
        >
          <Tooltip label="Ricarica opzioni">
            <ActionIcon size="1rem" variant="subtle" onClick={refetch}>
              <IconRefresh />
            </ActionIcon>
          </Tooltip>
          <span>{props.label}</span>
        </Group>
      }
      searchable
      nothingFoundMessage="Nessuna specialità trovata"
      placeholder={
        props.value?.length || 0 > 0 ? undefined : 'Seleziona le specialità'
      }
      data={data.map((speciality) => ({
        value: speciality.id,
        label: speciality.name,
      }))}
      disabled={isLoading || props.disabled}
    />
  ) : (
    <Select
      {...props}
      label={
        <Group
          display="inline-flex"
          w="max-content"
          gap="0.2rem"
          align="center"
        >
          <Tooltip label="Ricarica opzioni">
            <ActionIcon size="1rem" variant="subtle" onClick={refetch}>
              <IconRefresh />
            </ActionIcon>
          </Tooltip>
          <span>{props.label}</span>
        </Group>
      }
      searchable
      nothingFoundMessage="Nessuna specialità trovata"
      placeholder="Seleziona la specialità"
      data={data.map((speciality) => ({
        value: speciality.id,
        label: speciality.name,
      }))}
      disabled={isLoading || props.disabled}
    />
  );
}
